// extracted by mini-css-extract-plugin
export var attachButton = "_d0-8";
export var sendButton = "_d0-2";
export var sendDisabled = "_d0-4";
export var sendEnabled = "_d0-3";
export var sendIcon = "_d0-6";
export var sendIconDisabled = "_d0-7";
export var sendStreaming = "_d0-5";
export var textarea = "_d0-1";
export var wrapper = "_d0-0";